// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTable as RawLucideTable } from "lucide-react";
export const LucideTable = /* @__PURE__ */ createIcon(RawLucideTable, "LucideTable", 2);
